module.exports = __webpack_public_path__ + "img/2_3.2204f04b.jpg";